module.exports = __webpack_public_path__ + "assets/img/Tembusu Grand.fbeaedb9.png";